// ServiceSpecificationに基づいてMarketing（マーケティング・販促）のFeatureFlagsを作成します。
import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'

// パートナー設定のマーケティング（販促）に関するFeatureFlagsを作成します。
// merchandising.ts と同様のパターンで、partner_config.ts の
// createServiceSpecificationBackedFeatureFlags にスプレッドして組み込まれます。
export function createPartnerConfigFeatureFlagsMarketingPart(spec: ServiceSpecification) {
  return {
    get enablePointCampaign(): boolean {
      // ServiceSpecのfieldが未定義（古いSpecやフィールド追加前のパートナー）のときは
      // fallback値が使われるようにfalseを返す。trueチェックはundefinedを安全に扱うため。
      return spec.marketing?.enablePointCampaign === true
    },
  }
}
